import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0E44\u0E17\u0E22",
  code: "th",
  messages: {
    inputMenu: {
      noMatch: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      create: '\u0E2A\u0E23\u0E49\u0E32\u0E07 "{label}"'
    },
    calendar: {
      prevYear: "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
      nextYear: "\u0E1B\u0E35\u0E16\u0E31\u0E14\u0E44\u0E1B",
      prevMonth: "\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
      nextMonth: "\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E16\u0E31\u0E14\u0E44\u0E1B"
    },
    inputNumber: {
      increment: "\u0E40\u0E1E\u0E34\u0E48\u0E21",
      decrement: "\u0E25\u0E14"
    },
    commandPalette: {
      placeholder: "\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E49\u0E19\u0E2B\u0E32...",
      noMatch: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      close: "\u0E1B\u0E34\u0E14"
    },
    selectMenu: {
      noMatch: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
      create: '\u0E2A\u0E23\u0E49\u0E32\u0E07 "{label}"',
      search: "\u0E04\u0E49\u0E19\u0E2B\u0E32..."
    },
    toast: {
      close: "\u0E1B\u0E34\u0E14"
    },
    carousel: {
      prev: "\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A",
      next: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
      goto: "\u0E44\u0E1B\u0E17\u0E35\u0E48 {slide}"
    },
    modal: {
      close: "\u0E1B\u0E34\u0E14"
    },
    slideover: {
      close: "\u0E1B\u0E34\u0E14"
    },
    alert: {
      close: "\u0E1B\u0E34\u0E14"
    },
    table: {
      noData: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25"
    }
  }
});
